import React from 'react';
import { X, Check } from 'lucide-react';
export function SolutionTransition() {
  return <section className="py-16 px-4 bg-[#111]" aria-label="Comparación entre YouTube y el Sistema Mega Pack" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white uppercase tracking-tight" data-id="element-217">
          Esto no es un tutorial de YouTube. Es un sistema.
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-218">
          {/* YouTube Column */}
          <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" role="region" aria-label="Desventajas de YouTube" data-id="element-219">
            <div className="flex items-center justify-center gap-2 mb-8 pb-4 border-b border-gray-800" data-id="element-220">
              <X className="w-8 h-8 text-red-500" aria-hidden="true" data-id="element-221" />
              <h3 className="text-2xl font-bold text-gray-400" data-id="element-222">YouTube</h3>
            </div>
            <ul className="space-y-6 list-none p-0" data-id="element-223">
              {['Videos sueltos y desordenados', 'Información incompleta o vieja', 'Nadie te enseña a cotizar en Argentina', 'No sabés cómo conseguir clientes', 'Dudas constantes en medio de la obra'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-500" data-id="element-224">
                  <X className="w-5 h-5 text-red-500/50 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-225" />
                  <span className="text-lg" data-id="element-226">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Mega Pack Column */}
          <div className="bg-gradient-to-b from-[#1a1a1a] to-[#221a0f] p-8 rounded-2xl border-2 border-amber-600/50 shadow-xl shadow-amber-900/20 relative" role="region" aria-label="Ventajas del Sistema Mega Pack" data-id="element-227">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wider" data-id="element-228">
              La solución
            </div>
            <div className="flex items-center justify-center gap-2 mb-8 pb-4 border-b border-amber-900/30" data-id="element-229">
              <Check className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-230" />
              <h3 className="text-2xl font-black text-amber-500" data-id="element-231">
                Sistema Mega Pack
              </h3>
            </div>
            <ul className="space-y-6 list-none p-0" data-id="element-232">
              {['Paso a paso estructurado desde cero', 'Materiales exactos y proporciones claras', 'Presupuesto y cálculo de costos reales', 'Sistema probado para atraer clientes', 'Seguridad para cobrar tu primer trabajo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200" data-id="element-233">
                  <Check className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-234" />
                  <span className="text-lg font-medium" data-id="element-235">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-236">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-237">
            Un método claro para que tu primer trabajo salga bien y lo puedas
            cobrar con confianza.
          </p>
        </div>
      </div>
    </section>;
}